import { HOTEL_LIST_VIEW_ONLY, HOTEL_LIST_MAP_VIEW, HOTEL_LIST_SIMPLE } from './HotelMap';
import { ACCESSIBILITY_FILTER_UNCHECKED, ACCESSIBILITY_FILTER_VISIBILITY } from './AccessibilityTypes';
import { USE_POINTS_FILTER_UNCHECKED, USE_POINTS_FILTER_VISIBILITY } from './UsePointsTypes';

export const hideHotelListingFilters = [
    { key: 'brands', label: 'Brands' },
    { key: 'destinations', label: 'Destinations' }
];

export const hideProductListingFilters = [
    { key: 'roomViews', label: 'Room Views' },
    { key: 'bedType', label: 'Bed Type' },
    { key: 'rateType', label: 'Rate Type' },
    { key: 'roomCategory', label: 'Room Category' },
    { key: 'roomType', label: 'Room Type' },
    { key: 'price', label: 'Price' }
];

export const showUnavailableHotels = [
    { key: true, label: 'Available Only' },
    { key: false, label: 'Both Available and Unavailable' }
];

export const defaultProductView = [
    { key: 'listView', label: 'List View' },
    { key: 'cardView', label: 'Grid View' },
    { key: 'splitView', label: 'Split View' }
];

export const defaultSortSettings = [
    { key: 'recommended', label: 'Recommended (order determined by hotelier)' },
    { key: 'priceLowestToHighest', label: 'Lowest Price' }
];

export const calendarPriceDisplay = ['Minimum', 'Maximum', 'Average', 'None'];

export const childrenMaxAgeValue = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];

export const altAvailDistanceLimit = [1, 5, 10, 15, 20, 30].map(e => ({ key: e, label: e }));

export const hotelListDisplay = [
    { key: HOTEL_LIST_VIEW_ONLY, label: 'Hotel List View Only' },
    { key: HOTEL_LIST_MAP_VIEW, label: 'Hotel List & Map View' },
    { key: HOTEL_LIST_SIMPLE, label: 'Hotel List Simple' }
];

export const accessibilityFilterUnchecked = [{
    key: ACCESSIBILITY_FILTER_UNCHECKED.SHOW_ACCESSIBLE_BOTH,
    label: 'Show both regular and accessible room types'
}, {
    key: ACCESSIBILITY_FILTER_UNCHECKED.SHOW_REGULAR_ONLY,
    label: 'Show regular rooms only'
}];

export const accessibilityFilterVisibility = [{
    key: ACCESSIBILITY_FILTER_VISIBILITY.NOT_SHOW_ACCESSIBLE_FILTERS,
    label: "Don't show Accessibility filters"
}, {
    key: ACCESSIBILITY_FILTER_VISIBILITY.SHOW_ACCESSIBILITY_FILTER_BOTH,
    label: 'Show Accessibility filter on the filter bar above the product list AND in the filters menu'
}, {
    key: ACCESSIBILITY_FILTER_VISIBILITY.SHOW_ACCESSIBILITY_FILTER_PANEL_ONLY,
    label: 'Show Accessibility filters in the filters menu only'
}];

export const usePointsFilterUnchecked = [{
    key: USE_POINTS_FILTER_UNCHECKED.SHOW_USE_POINTS_BOTH,
    label: 'Show both regular and rooms with points'
}, {
    key: USE_POINTS_FILTER_UNCHECKED.SHOW_REGULAR_ONLY,
    label: 'Show regular rooms only'
}];

export const usePointsFilterVisibility = [{
    key: USE_POINTS_FILTER_VISIBILITY.NOT_SHOW_USE_POINTS_FILTERS,
    label: "Don't show Use Points filters"
}, {
    key: USE_POINTS_FILTER_VISIBILITY.SHOW_USE_POINTS_FILTER_BOTH,
    label: 'Show Use Points filter on the filter bar above the product list AND in the filters menu'
}, {
    key: USE_POINTS_FILTER_VISIBILITY.SHOW_USE_POINTS_FILTER_PANEL_ONLY,
    label: 'Show Use Points filters in the filters menu only'
}];

export const altAvailDistanceLimitUnit = [
    { key: 'kilometers', label: 'Kilometers' },
    { key: 'miles', label: 'Miles' }
];

export const altAvailType = [
    { key: 'none', label: 'None' },
    { key: 'onlyAltAvail', label: 'Only Alternate Availability' },
    { key: 'onlyHotelGeneralAvail', label: 'Only Hotel General Availability' },
    { key: 'firstHotelGeneralThenAltAvail', label: 'First Hotel General, Then Alternate Availability' }
];

export const altAvailSortOrder = [
    { key: 'hotelName', label: 'Hotel Name' },
    { key: 'random', label: 'Random' },
    { key: 'distance', label: 'Distance' },
    { key: 'altAvailBrand', label: 'Alternate Availability Brand' },
    { key: 'altAvailBrandThenDistance', label: 'Alternate Availability Brand, then Distance' }
];

export const defaultSplitViewType = [
    { key: 'room', label: 'Room' },
    { key: 'rate', label: 'Rate' }
];

export const splitViewExpandOption = [
    { key: 'expandFirstProduct', label: '1' },
    { key: 'expandFirstTwoProducts', label: '2' },
    { key: 'expandFirstThreeProducts', label: '3' },
    { key: 'expandAllProducts', label: 'All' }
];

export const roomCategoryExpandOption = [
    { key: 'expandFirstThreeCategories', label: 'Expand First Three Categories' },
    { key: 'expandAll', label: 'Expand All Categories' },
    { key: 'collapseAll', label: 'Collapse All Categories' }
];

export const roomCategoryViewOption = [
    { key: 'showIndividualRoomCards', label: 'Show individual room cards in the category grouping' },
    {
        key: 'showRoomsSmallSelectableList',
        label: 'Show rooms as a small selectable list (Eg. King, Queen, Garden View, Ocean View)'
    }
];

export const inContextRoomCategoryViewOption = [
    {
        key: 'showRoomsGrouping',
        label: 'Show rooms as grouped categories'
    },
    {
        key: 'showRoomsSmallSelectableList',
        label: 'Show rooms as a small selectable list'
    }
];

export const inContextRoomCategoryExpandOption = [
    { key: 'expandFirstThreeCategories', label: 'Expand First Three Categories' },
    { key: 'expandAll', label: 'Expand All Categories' },
    { key: 'collapseAll', label: 'Collapse All Categories' }
];

export const configurationActions = [
    'TOGGLE_BOOLEAN_VALUE_IN_CONFIG',
    'SET_BOOLEAN_VALUE_IN_CONFIG',
    'SET_TEXT_VALUE_IN_CONFIG',
    'SET_NUMBER_VALUE_IN_CONFIG',
    'ADD_CONFIG_ROW',
    'CHANGE_CONFIG_ROW',
    'EDIT_CONFIG_ROW',
    'DELETE_CONFIG_ROW',
    'SET_CUSTOM_CONTENT_TEXT_VALUE_IN_CONFIG',
    'MAKE_INVISIBLE_FILTERS',
    'MAKE_VISIBLE_FILTERS',
    'UNSET_VALUE_IN_CONFIG',
    'SET_LIST_VALUE_IN_CONFIG'
];

export const thirdpartyActions = ['SET_THIRDPARTY_DOMAINS'];

export const showLeadAvailabilityPrices = [
    { key: 'MinimumAvg', label: 'Lowest Average Daily Rate' },
    { key: 'NoPrice', label: 'No Price' },
    { key: 'PriceRange', label: 'Price Range' }
];

export const roomUpsellPriceDisplayTypes = [
    { key: 'averagePerNightDifference', label: 'Average Per Night Difference' },
    { key: 'averagePerNight', label: 'Average Per Night' }
];

export const productSegmentationFilter = [
    { key: 'dontShow', label: `Don't show segments` },
    { key: 'mealPlan', label: 'Meal Plan' },
    { key: 'rateName', label: 'Rate Name' },
    { key: 'roomCategoryName', label: 'Room Category Name' },
    { key: 'roomName', label: 'Room Name' }
];

export const requestedRatesSorting = [
    { key: 'RequestedPrivateThenRequestedPublicThenPublicRates', label: 'Sort requested public rates above other available public rates.' },
    { key: 'RequestedPrivateThenPublicRates', label: 'Sort requested and other available public rates together as set in Control Center.' }
];



// WEBPACK FOOTER //
// ./src/constants/configurationListItems.js